document.addEventListener('DOMContentLoaded', () => {
  let toast = null;

  function createToast() {
    toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.textContent = 'Added to cart';
    document.body.appendChild(toast);
  }

  function showToast() {
    if (!toast) createToast();
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 2500);
  }

  // Catch all Add to Cart events
  document.body.addEventListener('submit', function(e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (form) setTimeout(showToast, 50);
  });

  document.body.addEventListener('click', function(e) {
    const btn = e.target.closest('[type="submit"], button, a');
    if (!btn) return;
    const form = btn.closest('form[action*="/cart/add"]');
    if (form) setTimeout(showToast, 50);
  });
});